function validateNumber(evt) {
    var theEvent = evt || window.event;
    // Handle paste
    if (theEvent.type === 'paste') {
        key = window.event.clipboardData.getData('text/plain');
    }
    else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) {
            theEvent.preventDefault();
        }
    }
}
function handleXhrError(jqXhr, textStatus, error) {
    console.error(textStatus, error);
    console.log(jqXhr);
}
var accountApi = window.accountApi;
var apiStoreEndpoint = window.apiStoreEndpoint;
function showHideButton3Finish() {
    var heatingType = $('input:radio[name="heating"]:checked').val();
    var coolingType = $('input:radio[name="cooling"]:checked').val();
    if (heatingType !== undefined && coolingType !== undefined) {
        $('#step3button').removeAttr('disabled');
        $('#step3button').removeClass('disabled');
    }
}
// setup - functionality to step through cards
document.addEventListener("DOMContentLoaded", function () {
    // shared variables
    var accountNumber;
    var zipCode;
    var heatingType;
    var coolingType;
    let isDrAgreed = "No";
    let drTimestamp = "";
    let hasDrProduct = false;
    let hasGoogleDrProduct = false;
    let isDisclaimerChecked = false;
    // Check local storage to see if some products are ineligible, display appropriate message, clear from local storage
    const someProductsInelligible = localStorage.getItem('someProductsInelligible');
    if (someProductsInelligible === 'true') {
        $('#no_rebates_message').show();
    }
    else {
        $('#no_rebates_message').hide();
    }
    localStorage.removeItem('someProductsInelligible');
    $(document).on('click', '.override_quantity_plus', function () {
        $.ajax({
            type: "POST",
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                items: [{
                        quantity: 1,
                        id: window.location.href.includes('entergy-solutions-ms-marketplace-test-site')
                            ? 40803840196762
                            : 44263466959039
                    }]
            }
        }).fail(handleXhrError);
    });
    // Reset the rebate application logic whenever the quantity changes
    $(document).ajaxSend(function (event, jqxhr, settings) {
        if (settings.type === "POST" && settings.url === "/cart/change.js") {
            localStorage.removeItem("eml-rebates-applied");
        }
    });
    // when a user hits the plus and minus buttons, the script.js file does some weird ajax thing
    //    to update the values without reloading the page. We watch for changes later on and run.
    //    this function to check the cart json object and show or hide the button as needed
    function showHideCheckoutButtons() {
        $.getJSON('/cart.js', function (cart) {
            const hasAllRequiredAttributes = () => {
                const requiredAttributes = ['accountNumber', 'zipCode', 'heating_type', 'cooling_type'];
                return requiredAttributes.every(attr => cart.attributes && cart.attributes[attr]);
            };
            // Information needed to determine application state
            var rebateableCollections = [
                'Thermostat',
                'Power Strip',
                'Water',
                // TODO lighting is only temporarily unrebateable, uncomment this to start allowing incenvies again
                //'Lighting'
                'Air Purifier'
            ];
            var collectionsRegex = new RegExp(rebateableCollections.join("|"), "i");
            var rebateableSkus = ['ECK-EML-KIT-2025', 'ECK-EML-StormPack25'];
            var hasRebateable = cart.items.some(function (item) {
                return collectionsRegex.test(item.product_type)
                    || rebateableSkus.includes(item.sku);
            });
            var rebatesApplied = localStorage.getItem("eml-rebates-applied") === "true";
            const drProduct = cart.items.find(item => item.sku.endsWith("DR"));
            const googleDrProduct = cart.items.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.sku) === null || _a === void 0 ? void 0 : _a.endsWith("DR")) && (item === null || item === void 0 ? void 0 : item.vendor) === 'Google'; });
            hasGoogleDrProduct = Boolean(googleDrProduct) && Number(googleDrProduct.quantity) > 0;
            hasDrProduct = Boolean(drProduct) && Number(drProduct.quantity) > 0;
            var hasDisabledVariant = cart.items.some(function (item) {
                var disabledVariants = [
                    // prod
                    44263466959039,
                    44603152531647,
                    // test
                    42545993482394,
                    40803840196762,
                    62198426861939
                ];
                var rebatedVariants = [
                    // prod
                    44263466991807,
                    44603152564415,
                    // test
                    42545993515162,
                    40803840229530,
                    62198426894707
                ];
                return rebateableSkus.includes(item.sku)
                    && (disabledVariants.includes(item.variant_id)
                        || rebatedVariants.includes(item.variant_id)
                            && item.quantity > 1);
            });
            // Show rebates button group only if there are any rebateable items in the cart
            $("#apply-rebates-button-group").toggle(hasRebateable);
            // Checkout button is disabled if there is a disabled variant
            const disableCheckout = hasDisabledVariant || (hasDrProduct && !rebatesApplied && !hasAllRequiredAttributes());
            var checkoutButton = $('#checkout-button');
            checkoutButton.prop('disabled', disableCheckout);
            $('#apply-rebates-button').prop('disabled', rebatesApplied);
            checkoutButton.on("click", () => {
                const params = {
                    checkout: {
                        shipping_address: {
                            province: "MS"
                        }
                    }
                };
                const url = "/checkout?" + decodeURIComponent($.param(params));
                window.location.href = url; // "/checkout?" + decodeURIComponent($.param(params))
            });
            // If there are rebateable items, if there are no disabled variants, and rebates have been applied, allow checkout
            var checkoutLabel = disableCheckout
                ? checkoutButton.attr("data-disabled-checkout")
                // If there are no rebateable items, allow user to check out at full price
                : !hasRebateable || !rebatesApplied
                    ? checkoutButton.attr("data-unrebated-checkout")
                    // Otherwise, show ordinary checkout message
                    : checkoutButton.attr("data-checkout");
            checkoutButton.text(checkoutLabel);
            checkoutButton.val(checkoutLabel);
            checkoutButton.attr('aria-label', checkoutLabel);
            // If there is a disabled variant, show the disabled variant warning
            $("#disabled_checkout_relief_kit_message").toggle(hasDisabledVariant);
            $("#disabled_checkout_DR_message").toggle(hasDrProduct && !rebatesApplied);
        });
    }
    // check which button to show on page load
    showHideCheckoutButtons();
    // check what buttons to show as items are added and removed from cart
    $(document).on("click", ".qtybtn", function () {
        var oldTotalValue = $('#total-cart-bottom').text();
        var intervalId = setInterval(function () {
            if ($('#total-cart-bottom').text() != oldTotalValue) {
                showHideCheckoutButtons();
                clearInterval(intervalId);
            }
        }, 100);
    });
    function goToStep(step) {
        const visibility = {
            '#card-1': step === 'terms',
            '#card-2': step === 'eligibility',
            '#card-3': step === 'equipment',
            '#loading-card': step === 'verifying'
        };
        for (const key in visibility) {
            $(key).toggleClass('hidden', !visibility[key]);
        }
    }
    //DR
    function canEnableEligibilityCheck(accountNumber, zipCode) {
        return (accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.length) >= 12 && (zipCode === null || zipCode === void 0 ? void 0 : zipCode.length) >= 5;
    }
    function toggleEligibilityCheck(enabled) {
        if (enabled) {
            $('#step2button').prop("disabled", false);
            $('#step2button').removeClass('disabled');
        }
        else {
            $('#step2button').prop("disabled", true);
            $('#step2button').addClass('disabled');
        }
    }
    function handleAccountInfoChanged() {
        var accountNumber = $("#account_number").val();
        var zipCode = $("#zip_code").val();
        var enabled = canEnableEligibilityCheck(accountNumber, zipCode);
        toggleEligibilityCheck(enabled);
    }
    $("#account_number").on("change keyup paste", handleAccountInfoChanged);
    $("#zip_code").on("change keyup paste", handleAccountInfoChanged);
    $('#step2button').on('click', function () {
        var accountNumberInput = $("#account_number").val();
        var zipCodeInput = $("#zip_code").val();
        if (accountNumberInput.length < 13) {
            var itemsToAdd = 13 - accountNumberInput.length;
            accountNumberInput = Array(itemsToAdd).join("0") + accountNumberInput;
        }
        $('#cannot-find-you').hide();
        goToStep("verifying");
        accountApi.getInfoFromAccountNumber(accountNumberInput, zipCodeInput)
            .done(function (data) {
            const validResult = data.count === 1;
            $('#cannot-find-you').toggle(!validResult);
            if (validResult) {
                accountNumber = accountNumberInput;
                zipCode = zipCodeInput;
                addNotesToCart([
                    { key: 'accountNumber', value: accountNumber },
                    { key: 'zipCode', value: zipCode },
                ]);
                goToStep("equipment");
            }
            else {
                goToStep("eligibility");
            }
        })
            .fail(function (jqXhr, textStatus, error) {
            handleXhrError(jqXhr, textStatus, error);
            goToStep("eligibility");
        });
    });
    // fire the initial fancybox modal window
    $("#apply-rebates-button").on('click', function () {
        if (Boolean(hasDrProduct)) {
            $("#dr-agreement-content").show();
        }
        if (Boolean(hasGoogleDrProduct)) {
            $("#dr-google-agreement").show();
        }
        $.fancybox.open({
            src: '#fancybox-popup-form',
            type: 'inline'
        });
    });
    $(`#dr-agreement-checkbox`).on('change', function () {
        if ($(this).prop("checked")) {
            drTimestamp = new Date(Date.now()).toISOString();
            isDrAgreed = "Yes";
        }
        else {
            drTimestamp = "";
            isDrAgreed = "No";
        }
        const isDrAgreementValid = (isDrAgreed === "Yes" && Boolean(isDisclaimerChecked));
        $('#step1button').prop('disabled', isDrAgreementValid ? false : true);
        isDrAgreementValid ? $('#step1button').removeClass("disabled") : $('#step1button').addClass("disabled");
    });
    // move from step 1 to step 2 card
    $('#step1button').on('click', function () {
        goToStep("eligibility");
    });
    // move from step 2 card back to step 1
    $('.goToStep1').on('click', function () {
        goToStep("terms");
    });
    $('#step3BackButton').on('click', function () {
        goToStep("eligibility");
    });
    $('#step3button').on('click', function () {
        // localStorage.setItem("eml-rebates-applied", "true")
        addNotesToCart([
            { key: 'accountNumber', value: accountNumber || '' },
            { key: 'needsAccountInfo', value: 'true' },
            { key: 'heating_type', value: heatingType },
            { key: 'cooling_type', value: coolingType },
            { key: 'DRagree', value: isDrAgreed },
            { key: 'DRtimestamp', value: drTimestamp }
        ]).done(function () {
            $.ajax({
                url: "/cart.js",
                method: "GET",
                cache: false,
                dataType: "json",
                crossDomain: true,
            }).done(function (data) {
                // rebuild items object to be smaller
                var cartItems = data.items.map(function (item) {
                    return {
                        sku: item.sku,
                        variant_id: item.variant_id,
                        quantity: item.quantity,
                        title: item.title,
                    };
                });
                callShopifyQuantityCheck(accountNumber, zipCode, cartItems, function (shopifydata) {
                    var _a;
                    // get historic data
                    // get cart
                    // if cart over product limit show message
                    // if historic + cart over limit, show message
                    // else hide
                    if (shopifydata.length == 0) {
                        $('#ineligible_for_rebates_message').show();
                        console.log('no shopify data');
                        localStorage.removeItem("eml-rebates-applied");
                    }
                    else {
                        var tmpCartObj = JSON.parse(localStorage.getItem('tmpCartObj'));
                        var updateString = '';
                        let allProductsElligible = true;
                        for (const property of Object.keys(tmpCartObj)) {
                            if (((_a = tmpCartObj[property]) === null || _a === void 0 ? void 0 : _a.discounts.length) === 0) {
                                const shopifyCartItem = shopifydata.find(entry => entry.variant === property);
                                if (shopifyCartItem !== undefined && shopifyCartItem.quantity > 0) {
                                    allProductsElligible = false;
                                }
                            }
                        }
                        for (const product of shopifydata) {
                            updateString = updateString + 'updates[' + product.variant + ']=' + product.quantity + '&';
                        }
                        if (allProductsElligible) {
                            console.log('allProductsElligible');
                            localStorage.setItem('someProductsInelligible', 'false');
                            $('#no_rebates_message').hide();
                        }
                        else {
                            console.log('someProductsInelligible');
                            localStorage.setItem('someProductsInelligible', 'true');
                            $('#no_rebates_message').show();
                        }
                        if (shopifydata.length > 0) {
                            // update the cart contents if the user got rebated items
                            $.ajax({
                                type: "POST",
                                url: '/cart/update.js',
                                data: updateString.slice(0, -1),
                            }).done(function (data) {
                                var data = JSON.parse(data);
                                var items = data.items;
                                for (var i = 0; i < items.length; i++) {
                                }
                                history.go(0);
                            }).fail(handleXhrError);
                        }
                        localStorage.setItem("eml-rebates-applied", "true");
                    }
                });
            });
        });
        $.fancybox.close();
    });
    var callShopifyQuantityCheck = function (account, zipCode, items, callback) {
        $.ajax({
            url: apiStoreEndpoint + "/check-quantity-limits",
            type: "POST",
            contentType: "application/json",
            headers: { "X-Bot-Proof-Token": "EFVWJY4JoNEPJcTf0FWz" },
            data: JSON.stringify({
                account: account,
                zipCode: zipCode,
                heating: heatingType,
                cooling: coolingType,
                items: items
            }),
        })
            .done(callback)
            .fail(function (e) {
            let ineligibleMsg = 'An error occurred while checking for rebates';
            if (e.responseText === 'Missing heating type') {
                ineligibleMsg += ': Missing heating type';
            }
            else if (e.responseText === 'Missing cooling type') {
                ineligibleMsg += ': Missing cooling type';
            }
            else if (e.responseText === 'Unrebated relief kit') {
                ineligibleMsg += ': Each customer is limited to one Energy Efficiency Kit.';
            }
            $('#ineligible_for_rebates_message').text(ineligibleMsg);
            console.error(e);
            callback([]);
        });
    };
    // step 1
    // Check if the disclaimers are checked, if they are both checked, allow the continue button to not be disabled
    // Control UI, allow them to proceed if the boxes are checked, prevent further progress if they are unchecked
    $("#checkbox1").on('change', function () {
        if ($(this).prop("checked")) {
            isDisclaimerChecked = true;
            $('#step1button').prop('disabled', hasDrProduct && isDrAgreed === "No");
            (!hasDrProduct || isDrAgreed === "Yes") ? $('#step1button').removeClass("disabled") : $('#step1button').addClass("disabled");
        }
        else {
            isDisclaimerChecked = false;
            $('#step1button').prop('disabled', true);
            $('#step1button').addClass("disabled");
        }
    });
    function addNotesToCart(notesArray) {
        const noteString = notesArray
            .map(function (entry) {
            return 'attributes[' + entry.key + ']=' + entry.value;
        })
            .join('&');
        // add a note_attribute to the cart.
        // this is useful because it carries throughout the whole process.
        // once the order goes through, it is send to our backend to update the note object
        return $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: noteString
        }).fail(handleXhrError);
    }
    ;
    //step 3
    // As the user clicks, update the note, and continually check to see if both have something marked. If heating and cooling are answered,s end the cart to the backend to look up past participation
    $('input:radio[name="heating"]').on('change', function () {
        heatingType = $('input:radio[name="heating"]:checked').val();
        showHideButton3Finish();
    });
    $('input:radio[name="cooling"]').on('change', function () {
        coolingType = $('input:radio[name="cooling"]:checked').val();
        showHideButton3Finish();
    });
});
